import { ReactNode } from 'react'

import styled from '@emotion/styled'

import { ChameleonLink } from '@cash-design-system/react'

import { useLogout } from './logout'

const ErrorBanner = styled.div`
  background-color: ${({ theme }) => theme.colors.bannerTextError};
  border-radius: 0.5rem;
  color: ${({ theme }) => theme.colors.bannerBackgroundError};
  padding: ${({ theme }) => theme.spacing.m};
  position: fixed;
  top: 1rem;
  right: 1rem;
  z-index: 100;
`

// this is an internal development tool, and doesn't need to be translated
/* eslint-disable i18next/no-literal-string */
export const DevelopmentBanner = ({ children }: { children: ReactNode }) => {
  const logout = useLogout()

  return (
    <>
      {children}
      <ErrorBanner>
        GetProfile 401ed.{' '}
        <ChameleonLink href="#" onClick={() => window.location.reload()}>
          Reload
        </ChameleonLink>
        ?{' '}
        <ChameleonLink href="#" onClick={() => logout({ returnToSameUrl: true })}>
          Logout
        </ChameleonLink>
        ?
      </ErrorBanner>
    </>
  )
}
/* eslint-enable i18next/no-literal-string */
